import Authentication from "./authentication";
import SignIn from "./signin";
import Physicals from "./modules/physicals";
import Legals from "./modules/legals";
import States from "./modules/states";
import Cities from "./modules/cities";
import Districts from "./modules/districts";
import Addresses from "./modules/addresses";
import Professionals from "./modules/professionals";
import User from "./modules/user";
import Coupons from "./modules/coupons";
import Orders from "./modules/orders";
import Subscriptions from "./modules/subscriptions";
import Cloudinary from "./modules/cloudinary";
import Payments from "./modules/payments";
import Cycles from "./modules/cycles";
import Feedbacks from "./modules/feedbacks";
import Accounts from "./modules/accounts";
import AccountTermsOfUse from "./modules/accountTermsOfUse";
import ConfigurableFields from "./modules/configurableFields";
import ConfigurableFieldOption from "./modules/configurableFieldOption";
import OrderHasPreferences from "./modules/preferences/orderHasPreferences";
import CreditCards from "./modules/creditCards";
import Server from "./modules/server";
import Support from "./modules/support";
import OrderOffer from "./modules/order_offer";

export default {
  Authentication,
  SignIn,
  Physicals,
  Legals,
  States,
  Cities,
  Districts,
  Addresses,
  Professionals,
  User,
  Coupons,
  Orders,
  Subscriptions,
  Cloudinary,
  Payments,
  Cycles,
  Feedbacks,
  Accounts,
  AccountTermsOfUse,
  ConfigurableFields,
  ConfigurableFieldOption,
  OrderHasPreferences,
  CreditCards,
  Server,
  Support,
  OrderOffer
};



// WEBPACK FOOTER //
// ./src/api/index.js